import React from 'react'

import { StepType } from '@plvs/utils'
import { MatchAssistantAdapterStepValue } from '@plvs/rally/features/match/assistant/adapter/matchAssistantAdapterSteps'
import { MatchAssistantActions } from '@plvs/rally/features/match/assistant/MatchAssistantActions'
import { TeamReporting } from '@plvs/rally/features/match/assistant/steps/reporting/TeamReporting'
import { StageSelect as SplatoonStageSelect } from '@plvs/rally/features/match/assistant/steps/splatoon/stageSelect/StageSelect'
import { LoadoutSelect } from '@plvs/rally/features/match/assistant/steps/splatoon/loadoutSelect/LoadoutSelect'
import { MatchFinalScore } from '@plvs/rally/features/match/dynamic/matchFinalScore/MatchFinalScore'
import { HeadToHeadGamePreview } from '@plvs/rally/features/match/assistant/steps/general/gamePreview/HeadToHeadGamePreview'
import type { MatchAssistantAdapterProps } from './MatchAssistantAdapter.types'

export const splatoonMatchAssistantSteps = ({
  subtitle,
  generalSteps,
  isMatchComplete,
  match,
  setStepIndex,
  DisputeResultsButton,
}: MatchAssistantAdapterProps): Record<
  StepType | string,
  MatchAssistantAdapterStepValue
> => {
  return {
    ...generalSteps,
    [StepType.StageSelect]: [
      {
        step: <SplatoonStageSelect />,
        subtitle,
        title: 'Stage Select',
        actions: <MatchAssistantActions />,
      },
    ],

    [StepType.CharacterSelect]: [
      {
        step: <LoadoutSelect />,
        subtitle,
        title: 'Loadouts',
        actions: <MatchAssistantActions />,
      },
    ],

    [StepType.Report]: [
      {
        step: <HeadToHeadGamePreview onNext={setStepIndex} />,
        title: 'Game Preview',
        subtitle,
        actions: <MatchAssistantActions />,
      },
      {
        step: <TeamReporting />,
        title: 'Scoreboard',
        subtitle: isMatchComplete ? '' : subtitle,
        actions: <MatchAssistantActions />,
      },
    ],

    [StepType.Final]: [
      {
        step: <MatchFinalScore match={match} />,
        title: 'Final Score',
        subtitle: '',
        actions: DisputeResultsButton,
      },
    ],
  }
}
